import { createFileRoute } from "@tanstack/react-router";
import { ArgentinaHub } from "@/components/country/ar/ArgentinaHub";
import { CountrySwitcher } from "@/components/country/CountrySwitcher";

export const Route = createFileRoute("/argentina/")({
  head: () => ({
    meta: [
      { title: "VerseSport Argentina — La segunda pantalla de la hinchada Albiceleste" },
      { name: "description", content: "Predicciones, Nation Wars, ranking de la Albiceleste y comunidad argentina para vivir el Mundial." },
      { property: "og:title", content: "VerseSport Argentina — Segunda pantalla Albiceleste" },
      { property: "og:description", content: "La casa digital de la hinchada Albiceleste en el Mundial." },
      { property: "og:url", content: "https://versesport.com/argentina" },
      { property: "og:type", content: "website" },
    ],
    links: [{ rel: "canonical", href: "https://versesport.com/argentina" }],
    scripts: [{
      type: "application/ld+json",
      children: JSON.stringify({
        "@context": "https://schema.org",
        "@type": "WebSite",
        name: "VerseSport Argentina",
        url: "https://versesport.com/argentina",
        inLanguage: "es-AR",
      }),
    }],
  }),
  component: () => (
    <main className="mx-auto max-w-3xl space-y-4 px-3 py-4">
      <div className="flex items-center justify-end"><CountrySwitcher /></div>
      <ArgentinaHub />
    </main>
  ),
});